import React from 'react'
import Input from '../Input/Input'
import Container from '../Container/Container';
import Button from '../Button/Button';
import Heading from '../Heading/Heading';
import Error from '../Error/Error';
import {useNavigate} from 'react-router-dom';
import { useState, useEffect } from 'react';
import SyncLoader from "react-spinners/SyncLoader";

import { CreateListing } from './../apiCalls';

function ListingInformation(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [isInvalid, setIsInvalid] = useState(false);
  const [message, setMessage] = useState("");
  const Create = async() => {
    if(!isLoading) {
      let payload = {
        "Vendor-Email": window.email,
        "City": window.listingCity,
        "ImageLink": "link",
        "Name": window.listingName,
        "Phone": window.listingPhone,
        "Rating": 0,
        "State": window.listingState,
        "Street": window.listingStreet,
        "Tier": "Standard",
        "Zip": window.listingZip,
        "Distance": window.listingSalesRadius,
        "CustomerID":window.customerID,
        "ListingID":window.listingID
      }
      setIsLoading(true);
      let createStatus = await(CreateListing(payload));
      console.log(createStatus);
      setIsLoading(false);
      if(createStatus.Status == "Success"){
        window.name = createStatus.Name; 
        window.listingID = createStatus.ListingID;
        window.email = createStatus.ListingEmail;
        window.phone = createStatus.Phone;
        window.street = createStatus.Street;
        window.city = createStatus.City;
        window.state = createStatus.State;
        window.zip = createStatus.Zip;
        window.salesRadius = createStatus.SalesRadius;
        window.quotesThisMonth = createStatus.QuotesThisMonth;
        window.totalQuotes = createStatus.TotalQuotes;
        window.isLoggedIn = true;
        navigate("/Dashboard")
      } else if(createStatus.Status == 'Account Exists'){
        setIsInvalid(true);
        setMessage("Account Exists. Please login instead.");
      } else {
        setIsInvalid(true);
        setMessage("Something went wrong. Please try again.");
      }
    }
  }
  useEffect( () => {
    if(!window.email){
      navigate("/CreateAccount")
    }
  })
  const navigate = useNavigate()
  return (
    <div className='flex container sm:items-center sm:justify-center sm:mt-20'>
      <Container title="Create Account" className="sm:max-w-4xl">
        {isInvalid && (<Error text={message}/>)}
        <Heading text="Listing Information"/>
        <div className='sm:flex sm:flex-row sm:space-x-3'>
          <Input id="listingName" label="Business Name"/>
          <Input id="listingPhone" label="Business Phone Number"/>
        </div>
        <Heading text="Address"/>
        <div className='sm:flex sm:flex-row sm:space-x-3'>
          <Input id="listingStreet" label="Street" className="sm:basis-full"/>
          <Input id="listingCity" label="City" className="sm:basis-96"/>
          <div className='flex flex-row space-x-3'>
            <Input id="listingState" label="State" className="sm:basis-32 sm:grow-0"/>
            <Input id="listingZip" label="Zip" className="sm:basis-32 sm:grow-0"/>
          </div>  
        </div>
        <Heading text="Sales Radius"/>
        <p>* This will be used to determine if you can service the customer</p>
        <div className='flex flex-row justify-center items-center space-x-3'>
          <Input id="listingSalesRadius" />
          <Heading text="Miles"/>
        </div>
        <p className='mb-5'>* By pressing "Submit" you agree to the <u className='hover:cursor-pointer'>Terms & Conditions</u></p>
        <Button onClick={() => ValidateInputs()} title="">{isLoading ? <SyncLoader color='white'/> : "Submit"}</Button>
      </Container>
    </div>
  )

  function ValidateInputs() {
    let inptListingName = document.getElementById("listingName");
    let inptPhone = document.getElementById("listingPhone");
    let inptStreet = document.getElementById("listingStreet");
    let inptCity = document.getElementById("listingCity");
    let inptState = document.getElementById("listingState");
    let inptZip = document.getElementById("listingZip");
    let inptSalesRadius = document.getElementById("listingSalesRadius");

    if (inptListingName.value == "" || inptPhone.value == "" || inptStreet.value == "" || inptCity.value == "" || inptState.value == "" || inptZip.value == "" || inptSalesRadius.value == ""){
      setIsInvalid(true);
      setMessage("Fields cannot be empty.");
      return;
    }

    SetValues();
  }

  function SetValues(){
    window.listingName = document.getElementById("listingName").value
    window.listingPhone = document.getElementById("listingPhone").value
    window.listingStreet = document.getElementById("listingStreet").value
    window.listingCity = document.getElementById("listingCity").value
    window.listingState = document.getElementById("listingState").value
    window.listingZip = document.getElementById("listingZip").value
    window.listingSalesRadius = document.getElementById("listingSalesRadius").value
    
    Create();
  }


  function GoToRoute(r) {
    navigate('/' + r)
  }
}


export default ListingInformation
